import { Button, Flex, Typography } from '@iheartjane/reefer';
import { useLocation } from 'react-router';

import { useNavigateBack } from '@jane/shared/hooks';

import { Modal } from '../../components';
import type { RootLoaderType } from '../../data-access';
import { useKioskSpacing, useTypedRouteLoaderData } from '../../hooks';
import { useLogoutUser } from '../../providers';

export const Logout = () => {
  const { defaultSpacing, getKioskSpacing, isIpad } = useKioskSpacing();
  const { storeId } = useTypedRouteLoaderData<RootLoaderType>('root');
  const { pathname } = useLocation();
  const goBack = useNavigateBack(`stores/${storeId}/menu`);
  const { logout, logoutAndReset } = useLogoutUser();

  return (
    <Modal
      appId="root"
      contentLabel="Logout"
      onRequestClose={() => goBack()}
      open
      overlayClose
      variant="dialogue"
    >
      <Modal.Content>
        <Flex flexDirection="column">
          <Typography variant="title-bold" mb={getKioskSpacing(24, 8)}>
            {pathname.includes('cart') ? 'Sign out of' : 'Exit'} kiosk?
          </Typography>
          <Typography mb={defaultSpacing}>
            You will be signed out and your personal information will be
            permanently removed from this kiosk to protect your privacy.
          </Typography>
          <Button
            label={`${
              pathname.includes('cart') ? 'Sign' : 'Exit and sign'
            } out`}
            onClick={() => {
              if (pathname.includes('cart')) {
                logout();
                goBack();
              } else {
                logoutAndReset();
              }
            }}
            full
            branded
            mb={defaultSpacing}
            size={isIpad ? 'small' : 'default'}
          />
          <Button
            label="Cancel"
            onClick={() => goBack()}
            variant="tertiary"
            full
            branded
            size={isIpad ? 'small' : 'default'}
          />
        </Flex>
      </Modal.Content>
    </Modal>
  );
};
